import { FormattedMessage } from 'react-intl';

const intlPrefix = 'shoppingBag';

export const StrapSize = (
  <FormattedMessage
    defaultMessage='Strap size'
    id={`${intlPrefix}.strapSize`}
  />
);

export const StrapSizeMustBeSelected = (
  <FormattedMessage
    defaultMessage='A strap size must be selected'
    id={`${intlPrefix}.strapSizeMustBeSelected`}
  />
);
